import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { defaultSAL2040_R01Dto, SAL2040_R01Dto } from './Dto_SAL2040_R01';

export interface SAL2040_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	customCd: string;
	customNm: string;
	itemCd: string;
	itemNm: string;
	refetchListLength?: number;
}

export interface Store_SAL2040_R01 {
	SAL2040_R01Filter: SAL2040_R01Filter;
	SAL2040_R01PastFilter: SAL2040_R01Filter;
	setSAL2040_R01Filter: (filter: Partial<Store_SAL2040_R01['SAL2040_R01Filter']>) => void;
	setSAL2040_R01PastFilter: (filter: Store_SAL2040_R01['SAL2040_R01PastFilter']) => void;

	// ====== 매출 내역 리스트 ======
	SAL2040_R01List: SAL2040_R01Dto[];
	setSAL2040_R01List: (list: SAL2040_R01Dto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;

	allCount: number;
	setAllCount: (allCount: number) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;

	// ====== 초기화 ======
	initData: () => void;
}

export const defaultSAL2040_R01Filter: SAL2040_R01Filter = {
	compCd: '',
	dateRange: {
		from: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
		to: new Date()
	},
	customCd: '',
	customNm: '',
	itemCd: '',
	itemNm: ''
};

export const useSAL2040_R01Store = create<Store_SAL2040_R01>((set) => ({
	SAL2040_R01Filter: defaultSAL2040_R01Filter,
	SAL2040_R01PastFilter: defaultSAL2040_R01Filter,
	setSAL2040_R01Filter: (update) => set((state) => ({
		SAL2040_R01Filter: {
			...state.SAL2040_R01Filter,
			...update
		}
	})),
	setSAL2040_R01PastFilter: (filter: Store_SAL2040_R01['SAL2040_R01PastFilter']) => set((state) => {
		return {
			...state,
			SAL2040_R01PastFilter: filter
		}
	}),

	// ====== 매출 내역 리스트 ======
	SAL2040_R01List: [],
	setSAL2040_R01List: (list: SAL2040_R01Dto[]) => set((state) => {
		const newList = list.map((item, index) => ({
			...item,
			valueIndex: item.valueIndex > 0 ? item.valueIndex : index + 1,
			orderIndex: item.orderIndex > -1 ? item.orderIndex : index + 1,
			orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
		}));
		
		return {
			...state,
			SAL2040_R01List: newList
		};
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),

	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		SAL2040_R01Filter: defaultSAL2040_R01Filter,
		SAL2040_R01PastFilter: defaultSAL2040_R01Filter,
		SAL2040_R01List: [],
		allCount: 0,
		columnState: null,
		scrollTop: null,
	})),
}));

